import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Button, {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol
} from "../../components";
import Highlight from "react-highlight";
import { history } from "../../redux/store/configureStore";

class Categories extends PureComponent {

  handleClick = e => {
    e.preventDefault();
    const { history } = this.props;
    history.push("/categories/addCategory");
  };
  render() {
    return (
      <div>
        <h1>All Categories</h1>
        <button onClick={this.handleClick}> Add Categories </button>
      </div>
    );
  }
}

Categories.propTypes = {
  actions: PropTypes.shape({
    enterWorkProgress: PropTypes.func.isRequired,
    leaveWorkProgress: PropTypes.func.isRequired
  })
};

export default Categories;



// WEBPACK FOOTER //
// ./src/app/views/categories/Categories.js